/****************
 * The dashboard's regime widget: the shape the server sends and the two
 * decisions the widget makes, kept apart from the component so they are
 * tested on their own. Server side: backend/internal/api/rest/regime_read.go.
 ****************/

/** GET /api/v1/regime/live. `reading` is null until the tensor has sent one. */
export interface RegimeLiveResponse {
  widget_open: boolean;
  reading: RegimeReading | null;
  history: { as_of: string; easy_hard: number | null; volatility_intraday: number | null }[];
  stale_after_minutes: number;
}

export interface RegimeReading {
  as_of: string;
  computed_at: string;
  age_minutes: number;
  stale: boolean;
  /** 0 = hardest, 100 = easiest. */
  easy_hard: number | null;
  /** BTC's 24 h volatility against the last 90 days, 0-100. */
  volatility_intraday: number | null;
  volatility_multiday: number | null;
  /** BTC's trend phase: 1 bull, 2 correction, 3 bear, 4 rebound; 0 or less = unclear. */
  phase_intraday: number | null;
  phase_multiday: number | null;
}

/**
 * Who sees the widget. REGIME_WIDGET_USERS empty means the admins only: the
 * server cannot tell an admin (B-20), so the admins are this app's own list
 * and everyone else needs the server's widget_open.
 */
export function regimeWidgetVisible(isAdmin: boolean, widgetOpen: boolean | undefined): boolean {
  return isAdmin || widgetOpen === true;
}

/** The dashboard-namespace key for a trend phase code. */
export function phaseKey(code: number | null | undefined): string {
  switch (code) {
    case 1: return 'regime.phase.bull';
    case 2: return 'regime.phase.correction';
    case 3: return 'regime.phase.bear';
    case 4: return 'regime.phase.rebound';
    default: return 'regime.phase.unclear';
  }
}
